import {
    request,
} from '../request.js'

// 所有用户
export function allUserList(data) {
    return request({
        url: '/web/back/sys/user/getNoClientIdList ',
        method: 'post',
        data
    })
}

// 点击推送
export function push(data) {
    return request({
        url: '/web/back/sys/pushPhone/pushByCidList',
        method: 'post',
        data
    })
}
// 根据用户返回用户订阅的标签

export function getTag(data) {
    return request({
        url: '/web/back/sys/pushPhone/searchTagForUsers',
        method: 'post',
        data
    })
}
//点击tag获取文章
export function getTagAct(data) {
    return request({
        url: '/web/back/sys/pushPhone/searchDocForUsers',
        method: 'post',
        data
    })
}

// tag页的文章推送  /web/back/sys/pushPhone/pushSubscribeByCidList
export function reqPush(data) {
    return request({
        url: '/web/back/sys/pushPhone/pushSubscribeByCidList',
        method: 'post',
        data
    })
}